<button
  class="eg-icon-button eg-icon-button__{{ egBorderStyle }} eg-icon-button__{{ egButtonSize }}"
  [disabled]="disabled"
  fxLayoutAlign="center center"
>
  <img src="{{ icon }}" alt="{{ alt }}" [class]="iconClass" />
</button>
